module.exports = __webpack_public_path__ + "assets/padlock-1.75ea7a7685a1c6e38cf5b6ae1f9acc33.svg";


//////////////////
// WEBPACK FOOTER
// ./img/padlock-1.svg
// module id = 423
// module chunks = 0